import React , { useEffect, useState } from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";

import './css/termsofuse.css';
const Lienhe=()=> {
    const Handleclick =()=>{
        window.history.back();
    }
  return (
   <Layout>
        <div className="container">
        <div className="header row d-flex pdy-10 mgx-0 mgt-10">
            <div className="col-1 in-f" onClick={Handleclick}>
                <i className="fa fa-chevron-left"></i>
            </div>
            <div className="col-10 flex-center">
                <span className="text_14 font_700">Liên hệ Bibo Mart</span>
            </div>
            <div className="col-1"></div>
        </div>

          {/* <h1 className='d-none'>Liên hệ Bibo Mart</h1> */}
        <div className='container page-builder-ltr'>
          <div className='container-page-footer'>
            <p><em><strong>&nbsp;</strong></em><em><strong></strong></em></p>
            <div className="column main"><input name="form_key" type="hidden" value="pEWQEWy9lpb6irom"/>
                <div id="authenticationPopup" data-bind="scope:'authenticationPopup'">
                </div>
                <p><strong>&nbsp;</strong></p>
                <p><strong> CÁC KÊNH LIÊN HỆ VỚI BIBOMART</strong></p>
                <p><strong>&nbsp; &nbsp;1. Liên hệ Hotline 1800 6886</strong> (Miễn phí)</p>
                <p>&nbsp; &nbsp;- <strong>Nhánh 1:</strong> Đặt hàng, tư vấn sản phẩm, chương trình khuyến mãi từ <strong>Đà Nẵng</strong> đến các <strong>tỉnh phía Bắc</strong></p>
                <p>&nbsp; - <strong>Nhánh 2:</strong> Đặt hàng, tư vấn sản phẩm, chương trình khuyến mãi từ <strong>Quảng Nam</strong> đến các <strong>tỉnh phí Nam</strong></p>
                <p>&nbsp; - <strong>Nhánh 3:</strong> Giải quyết khiếu nại, tư vấn chính sách dành cho Khách hàng</p>
                <p>&nbsp; - <strong>Nhánh 4:</strong> Đăng ký lớp học Tiền sản, lớp học Dinh dưỡng</p>
                <p><strong>&nbsp; 2. Chat Messenger Facebook</strong></p>
                <p><span><span>&nbsp;&nbsp;<a href="https://www.messenger.com/t/BiBoMart.com.vn">m.me/BiBoMart.com.vn</a></span></span></p>
                <p><strong>&nbsp; 3. Liên hệ trực tiếp</strong></p>
                <p><strong>&nbsp; Văn phòng miền Bắc</strong>:</p>
                <p>&nbsp; Địa chỉ: Tầng 10, Tòa Handico, Đường Phạm Hùng, Phường Từ Liêm, Thành phố Hà Nội.</p>
                <p>&nbsp; Điện thoại: (024) 7309 1168</p>
                <p><strong>&nbsp; Văn phòng miền Nam:</strong></p>
                <p>&nbsp; Địa chỉ:&nbsp;Tầng 3, số 2A Nguyễn Oanh, Phường Hạnh Thông, TP.Hồ Chí Minh.</p>
                <p>&nbsp; Điện thoại:&nbsp;(028) 7308 1168</p>
                <div className="widget block block-static-block block-id67">
                </div>
            </div>
          </div>  
        </div>

        <div className="footer text_13 font_500">
            <div className="row">
                <div className="col-12">
                    <div className="card card-border flex-center-col">
                        <span className="">Mọi thắc mắc, vui lòng liên hệ:</span>
                        <span className="font_700 color_red">P. Chăm sóc Khách hàng</span>
                        <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                        <span className="">Hotline: 1800 6886 (Miễn phí)</span>
                        <span className="">Email: cskh@bibomart.com.vn</span>
                    </div>
                </div>
            </div>
            <div className="row mgt-30">
                <div className="col-12 flex-center-col">
                    <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                    <ul className="mgt-10">
                        <li>Trụ sở: 120 Trần Duy Hưng, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam.</li>
                        <li>Văn phòng Miền Bắc: Tầng 10, Tòa Handico, Đường Phạm Hùng, Phường Từ Liêm, Thành phố Hà Nội. Số điện thoại: (024) 7309 1168</li>
                        <li>Văn phòng Miền Nam: Tầng 3, số 2A Nguyễn Oanh, Phường Hạnh Thông, TP.Hồ Chí Minh, Việt Nam.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
   </Layout>
  )
}
export default Lienhe;